import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FileuploadService} from "../../service/http/fileupload.service";
import {MatDialog, MatSnackBar, Sort} from "@angular/material";
import {Hotspot} from "../../model/Hotspot";
import {HotspotCreatorService} from "../../service/http/hotspot-creator.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {of as observableOf} from "rxjs";
import {catchError, map, startWith, switchMap} from "rxjs/operators";
import {AcceptDeclineDialogComponent} from "../../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {Disclaimer} from '../../model/Disclaimer';
import {AddHotspotDotDialogComponent} from './workflow-hotspot-dot-setter/add-hotspot-dot-dialog/add-hotspot-dot-dialog.component';
import {LoadHotspotTemplateComponent as LoadHotspotTemplateCom} from './load-hotspot-template/load-hotspot-template.component';
import {LoadHotspotTemplateComponent} from './load-hotspot-template/load-hotspot-template.component';
import {SuccessSaveToastComponent} from '../../toast/success-save-toast/success-save-toast.component';
import {SaveHotspotTemplateNoRowToastComponent} from '../../toast/save-hotspot-template-no-row-toast/save-hotspot-template-no-row-toast.component';
import {DeleteHotspotTemplateComponent} from './delete-hotspot-template/delete-hotspot-template.component';
import {SuccessMessageToastComponent} from '../../toast/success-message-toast/success-message-toast.component';
import {RenameHotspotComponent} from './rename-hotspot/rename-hotspot.component';

@Component({
  selector: 'app-workflow-hotspot-creator',
  templateUrl: './workflow-hotspot-creator.component.html',
  styleUrls: ['./workflow-hotspot-creator.component.css']
})
export class WorkflowHotspotCreatorComponent implements OnInit {

  displayedColumns: string[] = ['id', 'title', 'actions'];
  data: Hotspot[] = [];
  isLoadingResults = false;
  currentPackageIdGlobal: any;

  public hotspotTemplateLoadName: string = '';
  selectedHotspotId: number;
  public hotspotTemplateName: string = '';
  public hotspotTemplateList: string[];


  hotspotTemplateNameFormControl = new FormControl('', [
    Validators.required
  ]);

  public hotspotTemplateFormGroup = new FormGroup({
    hotspotTemplateName: this.hotspotTemplateNameFormControl
  });

  hotspotTitleFormControl = new FormControl('', [
    Validators.required
  ]);

  public hotspotFormGroup = new FormGroup({
    hotspotTitle: this.hotspotTitleFormControl
  });


  constructor(private hotspotCreatorService: HotspotCreatorService,
              private translate: TranslateService,
              private _router: Router,
              public dialog: MatDialog,
              public snackBar: MatSnackBar) {
  }

  ngOnInit() {

    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if (currentPackageId !== null) {
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.hotspotCreatorService.getHotspotTemplateList().subscribe(data => {
      this.hotspotTemplateList = data;
    });

    this.loadTableData();
  }

  loadTableData() {

    this.hotspotCreatorService.getHotspotsForPackage(this.currentPackageIdGlobal).pipe(
      startWith([]),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.hotspotCreatorService.getHotspotsForPackage(this.currentPackageIdGlobal);
      }),
      map(data => {
        this.isLoadingResults = false;
        return data;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => {
      this.data = data;
    });

  }


  selectedRow(row) {
    this.selectedHotspotId = row.id;
  }

  saveHotspotTemplate() {

    if (this.selectedHotspotId === undefined) {
      let toast = this.snackBar.openFromComponent(SaveHotspotTemplateNoRowToastComponent, {
        duration: 5000,
        panelClass: ['white-snackbar']
      });
    }

    let hotspotTemplateName = this.hotspotTemplateName.replace(/ /g, "_").replace(/[^\w_]/g, "");

    if (this.hotspotTemplateList.includes(hotspotTemplateName) && this.selectedHotspotId !== undefined) {

      const dialogOverwriteTemplate = this.dialog.open(AcceptDeclineDialogComponent, {
        width: '250px',
        data: {
          title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
          message: this.translate.instant('A template with the same name already exists, do you want to overwrite it?'),
          icon: {
            add: false,
            name: ''
          }
        }
      });

      dialogOverwriteTemplate.afterClosed().subscribe(result => {
        if (result == true) {
          this.saveHotspotTemplateAfterChecks(hotspotTemplateName);
        }
      });

    } else {
      this.saveHotspotTemplateAfterChecks(hotspotTemplateName);
    }

  }

  private saveHotspotTemplateAfterChecks(hotspotTemplateName: string) {

    if (this.hotspotTemplateFormGroup.valid && this.selectedHotspotId !== undefined) {
      this.hotspotCreatorService.uploadHotspotTemplate(this.currentPackageIdGlobal, this.selectedHotspotId, hotspotTemplateName).subscribe(data => {
        let toast = this.snackBar.openFromComponent(SuccessSaveToastComponent, {
          duration: 2000,
          panelClass: ['white-snackbar']
        });

        this.hotspotCreatorService.getHotspotTemplateList().subscribe(data => {
          this.hotspotTemplateList = data;
        });
      });
    }

  }

  loadHotspotTemplate() {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('Do you really want to load the hotspot template?'),
        icon: {
          add: false,
          name: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {

        this.isLoadingResults = true;

        this.hotspotCreatorService.getHotspotDotLinks(this.currentPackageIdGlobal).subscribe(data => {

          this.hotspotCreatorService.loadTemplateAndCheckBaseIds(this.currentPackageIdGlobal, this.hotspotTemplateLoadName).subscribe(data => {

            this.isLoadingResults = false;

            let loadHotspotDia = this.dialog.open(LoadHotspotTemplateComponent, {
              width: '50%',
              height: '45%',
              data: {
                packageId: this.currentPackageIdGlobal,
                templateName: this.hotspotTemplateLoadName,
                data: data
              }
            });

            loadHotspotDia.afterClosed().subscribe(result => {
              this.loadTableData();
            });

          });
        });
      }
    });
  }


  deleteHotspot(hotSpotId: number) {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('Do you really want to delete the hotspot?'),
        icon: {
          add: false,
          name: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.hotspotCreatorService.deleteHotspotOfPackage(this.currentPackageIdGlobal, hotSpotId).subscribe(data => {
          this.loadTableData();
        });
      }
    });

  }

  renameHotspot(hotspotId: number, rowIndex: number) {

    let renameHotspotDialog = this.dialog.open(RenameHotspotComponent, {
      width: '23%',
      height: '10%',
      data: {
        packageId: this.currentPackageIdGlobal,
        hotspotId: hotspotId,
        hotspotTitle: this.data[rowIndex].title
      }
    });

    this.loadTableData();
    renameHotspotDialog.afterClosed().subscribe(result => {

      if (result !== undefined) {
        this.hotspotCreatorService.getHotspotTemplateList().subscribe(data => {

          let toast = this.snackBar.openFromComponent(SuccessMessageToastComponent, {
            duration: 2000,
            panelClass: ['white-snackbar']
          });

          this.hotspotTemplateList = data;
          this.loadTableData();
        });
      }
    });

  }

  addHotspot() {

    if (this.hotspotFormGroup.valid) {
      let hotspotTitle = this.hotspotFormGroup.get('hotspotTitle').value;
      this.hotspotCreatorService.addHotspotToPackage(this.currentPackageIdGlobal, hotspotTitle).subscribe(data => {
        this.loadTableData();
      });
      // this.hotspotFormGroup.setValue({hotspotTitle: ''});
    }
  }

  editHotspot(id: number) {
    this._router.navigate(['/upload/hotspot-dots/' + id]);
  }

  deleteHotspotTemplate() {

    let delHotspotDialog = this.dialog.open(DeleteHotspotTemplateComponent, {
      width: '23%',
      height: '10%',
      data: {
        hotspotTemplateList: this.hotspotTemplateList
      }
    });

    delHotspotDialog.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.hotspotCreatorService.getHotspotTemplateList().subscribe(data => {

          let toast = this.snackBar.openFromComponent(SuccessMessageToastComponent, {
            duration: 2000,
            panelClass: ['white-snackbar']
          });

          this.hotspotTemplateList = data;
        });
      }
    });

  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.compare(a.id, b.id, isAsc);
        case 'title':
          return this.compare(a.title, b.title, isAsc);

        default:
          return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
